/* global $ u ko */
import { Get } from 'common'
import uMessage from 'components/message'

let _model

async function getQuesitionTypes () {
  let data = await Get('/cpu-supplymgr/question/questionTypes')
  let result = []
  if (data.status) {
    for (let r of data.data.result) {
      let questionClass = {
        id: r.id,
        pid: '0',
        code: r.code,
        title: r.name,
        open: false
      }
      result.push(questionClass)
    }
  }
  return result
}

async function init (refer) {
  let questionClassData = await getQuesitionTypes()
  let vm = {
    model: _model,
    dropBtnShow: ko.observable(false),
    treemodel: new window.u.DataTable({
      meta: {
        'id': { 'value': '' },
        'pid': { 'value': '' },
        'code': { 'value': '' },
        'title': { 'value': '' },
        'innercode': { 'value': '' }
      }
    }),
    treeOption: {
      view: {
        showLine: false,
        showIcon: false,
        selectedMulti: false,
        dblClickExpand: true
      },
      edit: {
        enable: true,
        editNameSelectAll: true,
        removeTitle: '删除',
        renameTitle: '编辑',
        showRemoveBtn: false,
        showRenameBtn: false
      },
      data: {
        simpleData: {
          enable: true
        }
      },
      callback: {
        onRemove: function (e, treeId, treeNode) {
          return false
        },
        onClick: function (event, treeId, treeNode) {
          vm.model.setValue('id', treeNode.id)
          vm.model.setValue('code', treeNode.code)
          vm.model.setValue('name', treeNode.name)
          vm.dropBtnShow(true)
        }
      }
    },
    addNode: function () {
      vm.model.setValue('id', '')
      vm.model.setValue('code', '')
      vm.model.setValue('name', '')
      questionClassData = vm.treemodel.getSimpleData()
      vm.treemodel.setSimpleData(questionClassData)
      vm.dropBtnShow(false)
    },
    dropNode: function () {
      let id = vm.model.getValue('id')
      window.u.confirmDialog({
        id: 'confirmDialog',
        msg: '<span><i class="uf uf-exc-c-2 uf-delete"></i>您确要删除此分类吗?</span>',
        title: '确认删除',
        onOk: function () {
          let setOrder = async function () {
            let result = await Get('/cpu-supplymgr/question/deleteQuestionType?id=' + id)
            if (result.status === 1) {
              uMessage('success', result.msg)
              let questionClassData = await getQuesitionTypes()
              vm.treemodel.setSimpleData(questionClassData)
            } else {
              uMessage('fail', result.msg)
            }
          }
          setOrder()
        },
        onCancel: function () {}
      })
    }
  }
  vm.treemodel.removeAllRows()
  vm.treemodel.setSimpleData(questionClassData)
  let app = u.createApp()
  app.init(vm, $('#helpQuestionClass')[0])
}

let template = require('./index.html')
export default function (model) {
  _model = model.datatable
  return {
    init,
    template
  }
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/questionClass/index.js